import React from 'react';
import PropTypes from 'prop-types';
import {Grid,Cell,Button} from 'react-md';

let hideMe = {display:"none"};

const NavigationButton = function(props) {

    //Dynamically Set Footer Width
    let contentPanelLeft    =   0;
    let contentPanelWidth   =   0;
    if (document.getElementById('quizContainer') !== null){
        contentPanelLeft = document.getElementById('quizContainer').offsetLeft;
        contentPanelWidth   =   document.getElementById('quizContainer').offsetWidth;
    }

    var  hideSubmitBtn = {display:"none"}
    let submitTextAlign = 'center'
    if(props.hideNext!=true)
         submitTextAlign = 'right' ;
    var showSubmitBtn = {display:"block",textAlign:submitTextAlign}
    var tryAgain = {display:"block",textAlign:'left'}
    var explanationButton={ backgroundColor:'#FFA700'}
    let floatFooter = {
        position: 'fixed',
        bottom: '0px',
        left:contentPanelLeft+'px',
        width: contentPanelWidth+'px',
        backgroundColor: 'white',
        float: 'left',
        borderStyle: "solid",borderColor: "lightgrey",borderWidth:" 1px 1px 0px 2px",
      };
      //margin-left
    //var hideCorrectAnswerBtn = {display:"none",marginTop: "10px",marginLeft: "109px"}
    //Bug Id 174
    var showCorrectAnswerBtn = {display:"block",textAlign:'left'}
    var nextButtonStlye = {marginLeft:'3px',textAlign:'right'}
    if(props.showSkip === true){
        nextButtonStlye = {backgroundColor:"#d4df48",marginLeft:'3px', float:'right',}
    }



    return      <Grid  style={floatFooter} className='noMarigin noPadding ' >

                    <Cell size={6} phoneSize={2}  tabletSize={4} className=" text-align-center" style ={(props.tryAgainButtonDisplay ?
                     tryAgain : hideSubmitBtn)}>
                        <Button onClick={props.onPrevClick} style={{ backgroundColor:'#851e5e'}}

                            flat secondary swapTheming>Try Again</Button>&nbsp;
                         <Button onClick={props.onExplanationClick} 
                         style={(props.explanationButtonDisplay ? explanationButton : hideSubmitBtn)}
                            flat secondary swapTheming>Explanation</Button>
                    </Cell>
                    <Cell   size={props.hideNext!=true?6:12}
                            phoneSize={props.hideNext!=true?2:4}
                            tabletSize={props.hideNext!=true?4:8}
                            className="text-align-center" style ={(props.submitButtonDisplay ?
                                showSubmitBtn : hideSubmitBtn)}>
                        <Button  onClick={props.onSubmitClick}
                                flat primary swapTheming>Submit</Button>&nbsp;
                        <Button onClick={props.onExplanationClick} 
                        style={(props.explanationButtonDisplay ? explanationButton : hideSubmitBtn)}
                            flat secondary swapTheming>Explanation</Button>
                            
                            
                    </Cell>
                    <Cell size={6} phoneSize={2} tabletSize={4} className="text-align-center" style ={(props.displayCorrectAnswer ?
                        showCorrectAnswerBtn : hideSubmitBtn)}>
                        <Button flat secondary swapTheming onClick={props.showCorrectAnswer}  style={{backgroundColor:'#3396FF'}}
                        >Check Answer</Button>
                    </Cell>
                    <Cell   size={!props.tryAgainButtonDisplay  && !props.displayCorrectAnswer && !props.submitButtonDisplay?12:6}
                            phoneSize={!props.tryAgainButtonDisplay  && !props.displayCorrectAnswer && !props.submitButtonDisplay?4:2}
                            tabletSize={!props.tryAgainButtonDisplay  && !props.displayCorrectAnswer && !props.submitButtonDisplay?8:4}
                        className="text-align-center" style={props.hideNext?hideMe:nextButtonStlye} >
                        <Button onClick={props.liveAnalyticsClick}
                            flat secondary swapTheming 
                             style={props.liveAnalyticsButtonVisible ? {backgroundColor:'#ff3300'} : hideSubmitBtn}>Results from whole class</Button>&nbsp;
                        <Button onClick={props.onFeedbackClick}
                            style={(props.feedbackButtonVisible ? {backgroundColor:'#7F4FC9',color:'white'} : hideSubmitBtn)}
                            flat secondary swaptheming = "true">Feedback</Button>&nbsp;
                        <Button
                            onClick={props.onNextClick}
                            flat secondary swapTheming  style={{backgroundColor:'#005200'}}>Next Question</Button>
                    </Cell>

                </Grid>

};

NavigationButton.propTypes = {
    onPrevClick:PropTypes.func.isRequired,
    onSubmitClick:PropTypes.func.isRequired,
    onNextClick:PropTypes.func.isRequired,
    hidePrev:PropTypes.bool,
    hideSubmit:PropTypes.bool,
    hideNext:PropTypes.bool,

};


export default NavigationButton;
